import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-[#0A1420] text-white border-t border-[#5D676E]/25 overflow-hidden" data-testid="footer">
      <div className="absolute w-96 h-96 bg-[#31638C] opacity-10 rounded-full blur-3xl top-0 -left-48 animate-drift"></div>
      <div className="absolute w-80 h-80 bg-[#4A8BC2] opacity-10 rounded-full blur-3xl bottom-0 right-0 animate-float-slow"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-4">
            <img
              src="https://customer-assets-gfyr7b9c.emergentagent.net/job_php-sample-build/artifacts/ftajnjjx_New%20Noax%20Logo%20-%2003.png"
              alt="Noax Media — trusted partner for real-time lead generation, Medicare leads, and final expense leads"
              className="h-32 lg:h-40 w-auto mb-4 -ml-8 lg:-ml-12"
            />
            <p className="text-gray-500 leading-relaxed mb-6">
              Real-time leads that actually convert. Built by operators with 11+ years of experience in the trenches.
            </p>
            <div className="space-y-3">
              <div className="flex items-center text-gray-500 text-sm group cursor-pointer">
                <Mail size={16} className="mr-2 text-[#4A8BC2] group-hover:scale-110 transition-transform" />
                <span className="group-hover:text-white transition-colors">info@noaxmedia.com</span>
              </div>
              <div className="flex items-center text-gray-500 text-sm group cursor-pointer">
                <Phone size={16} className="mr-2 text-[#4A8BC2] group-hover:scale-110 transition-transform" />
                <span className="group-hover:text-white transition-colors">+1 (720) 604-9950</span>
              </div>
              <div className="flex items-center text-gray-500 text-sm">
                <MapPin size={16} className="mr-2 text-[#4A8BC2]" />
                <span>Serving clients nationwide</span>
              </div>
            </div>

            {/* Social */}
            <div className="flex items-center gap-3 mt-6" data-testid="footer-socials">
              <a
                href="https://www.facebook.com/profile.php?id=61592639841219"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full flex items-center justify-center border border-[#5D676E]/30 text-gray-400 hover:text-white hover:border-[#31638C]/70 hover:bg-[#31638C]/15 hover:-translate-y-0.5 transition-all duration-300 shadow-sm hover:shadow-[0_0_18px_rgba(74,139,194,0.35)]"
                data-testid="social-facebook"
              >
                <Facebook size={16} />
              </a>
              <a
                href="https://www.linkedin.com/company/noax-media/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 rounded-full flex items-center justify-center border border-[#5D676E]/30 text-gray-400 hover:text-white hover:border-[#31638C]/70 hover:bg-[#31638C]/15 hover:-translate-y-0.5 transition-all duration-300 shadow-sm hover:shadow-[0_0_18px_rgba(74,139,194,0.35)]"
                data-testid="social-linkedin"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 font-medium text-[#4A8BC2]">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-500 hover:text-white transition-colors text-sm">Home</Link></li>
              <li><Link to="/services" className="text-gray-500 hover:text-white transition-colors text-sm">Services</Link></li>
              <li><Link to="/about" className="text-gray-500 hover:text-white transition-colors text-sm">About</Link></li>
              <li><Link to="/blog" className="text-gray-500 hover:text-white transition-colors text-sm">Blog</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 font-medium text-[#4A8BC2]">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-500 text-sm">Real-Time Leads</li>
              <li className="text-gray-500 text-sm">Data Solutions</li>
              <li className="text-gray-500 text-sm">Live Transfers</li>
              <li className="text-gray-500 text-sm">Social Media Marketing</li>
              <li className="text-gray-500 text-sm">AI Automations</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 font-medium text-[#4A8BC2]">Verticals</h4>
            <ul className="space-y-3">
              <li className="text-gray-500 text-sm">Home Services</li>
              <li className="text-gray-500 text-sm">Insurance</li>
              <li className="text-gray-500 text-sm">Solar & Energy</li>
              <li className="text-gray-500 text-sm">Real Estate</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#5D676E]/25">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
            <p>© {currentYear} Noax Media. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <button className="hover:text-[#4A8BC2] transition-colors">Privacy Policy</button>
              <button className="hover:text-[#4A8BC2] transition-colors">Terms of Service</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
